//import { ref } from 'vue'

/**
 * Use the browser's setCustomValidity function to set up error message for the field as indicated by the "ref" attribute
 * @param {string} fieldRef - the ref of the field as used in the "ref" attribute in the <input> tag
 * @param {string} errorMsg - the error message
 */
 export function setFieldValidity(refs, fieldRef, errorMsg) {
  console.log(`Inside setFieldValidity, refs ==> `, refs);
  console.log(`Inside setFieldValidity, fieldRef ==> `, fieldRef);
  const fieldObj = refs[fieldRef];
  console.log(`Inside setFieldValidity, fieldObj ==> `, fieldObj);

  if (errorMsg) {
    if (Array.isArray(fieldObj)) {
      fieldObj.forEach(function(oneFieldObj) {
        // use the browser's setCustomValidity function to set up error message.
        oneFieldObj.setCustomValidity(errorMsg);
      });
    } else {
      fieldObj.setCustomValidity(errorMsg);
    }
  } else {
    if (Array.isArray(fieldObj)) {
      fieldObj.forEach(function(oneFieldObj) {
        oneFieldObj.setCustomValidity("");
      });
    } else {
      fieldObj.setCustomValidity("");
    }
  }

}    

/**
 * set field validity of all the given form fields with given error messages
 * @param {string} refs - the field refs of the form
 * @param {string} errorMsgs - the error messages for each error field
 */
/*
export function setFieldErrors(refs, errorMsgs) {
  const errorFields = Object.keys(errorMsgs);
  errorFields.forEach(function(errorField) {
    console.log("Inside setFieldErrors(), errorField ==> ", errorField);
    const fieldErrorMsgs = errorMsgs[errorField];
    console.log("Inside setFieldErrors(), fieldErrorMsgs ==> ", fieldErrorMsgs);
    if (ref(errorField)) {
      refs[errorField].setCustomValidity(fieldErrorMsgs);
    }
  });
}
*/

export function fieldValidationMessages(refs, field) {
  if (refs[field]) {
    return refs[field].validationMessage
  }
}  

